import { useContext } from "react";
import "../../../sass/views/dashboard/insurances/insurances.scss";
import React from "react";
import { Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";

// Components
import Header from "../Header";
import Footer from "../Footer";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useEffect } from "react";

// Context API
import { mobilePageContext } from "/src/App";
import { blobURL } from "common/StringUtils";
import { InsuranceContent } from "views/dashboard/insurances/Insurances";
import { LOCALES } from "common/constants";

const SidebarInsurances = ({ dashboardFooter }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);

  const mobilepageContext = useContext(mobilePageContext);
  const insuranceImage = `${blobURL}/insurance.jpg`;
  let language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="insurances-page home-page self_new">
      <Helmet>
        <title>
          {t(
            "Invozio's Insurance: Comprehensive Protection for Self-Employed Individuals"
          )}
        </title>
        <meta
          name="description"
          content={t(
            "Discover the insurance options Invozio offers for self-employed individuals. Learn about liability insurance, accident insurance, legal protection, and much more to ensure security when invoicing without a company."
          )}
        />
        {language === LOCALES.EN_US ? (
          <link rel="canonical" href="https://invozio.com/insurance" />
        ) : (
          <link rel="canonical" href="https://invozio.com/forsakring" />
        )}
      </Helmet>

      {mobilepageContext === false &&
      location?.pathname === "/mobile_Insurance_admin" ? (
        ""
      ) : (
        <Header />
      )}

      <div className="new_desgn_insurance new_margin_header">
        <Container className="p-0">
          <section className="insurns_wrap ins_respnvs insurn_respn">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="security_fntw">
                    <h1 className="security_about text-uppercase">
                      {t("Insurance")}
                    </h1>
                    <h3 className="fnt_family">
                      {t(
                        "Those who work via Invozio always have good basic protection via basic insurance that covers your basic needs"
                      )}
                    </h3>

                    {!user && (
                      <Button
                        variant=""
                        className="mt-3 new_theme_btn "
                        onClick={() =>
                          navigate(
                            language === LOCALES.EN_US
                              ? `/emailregister?lang=${LOCALES.EN_US}`
                              : `/e-postregister?lang=${LOCALES.SV_SE}`
                          )
                        }
                      >
                        {t("Create Free Account")}
                      </Button>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="img-group">
                    <img
                      src={insuranceImage}
                      alt="insurance"
                      className="image-fluid"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <InsuranceContent />
        </Container>
      </div>

      {mobilepageContext === false &&
      location?.pathname === "/mobile_Insurance_admin" ? (
        ""
      ) : (
        <Footer dashboardFooter={dashboardFooter} />
      )}
    </div>
  );
};

export default SidebarInsurances;
